<mat-accordion>
  <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"  [expanded]="panelOpenState()" id="main" *ngIf="Series==='HP' || Series==='HPNOFAN'" class="border">
    <mat-expansion-panel-header *ngIf="showcdinfo" style="background: black; height: 50px;">
     <div class="container-fluid" style="background: black;display: flex;align-items: center;justify-content: space-between;">
        
        <h5 class="mb-0 text-white">Reducer Size
        </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
        <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
     </div>
    </mat-expansion-panel-header>

    <mat-expansion-panel-header *ngIf="showspinfo" style="background: #e2001a; height: 50px;">
     <div class="container-fluid" style="background: #e2001a;display: flex;align-items: center;justify-content: space-between;">
        
        <h5 class="mb-0 text-white">Reducer Size
        </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
        <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
     </div>
    </mat-expansion-panel-header>
<div *ngIf="signalStatus==true">
    
    
      <div class="card">
        <div class="justify-content-center">
          <div class="row">
              <div class="col-md-6">
                  <table class="table table-bordered table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col">Specification</th>
                          <th scope="col">Imperial</th>
                          <th scope="col">Metric</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td scope="row">Series</td>
                          <td id="series">HP</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td scope="row">Size Of Unit</td>
                          <td id="size">{{Size}}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td scope="row">Nominal Ratio</td>
                          <td id="ratio">{{formSelectionData.SelectedRatio}}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td scope="row">Input Speed</td>
                          <td id="speed">{{formSelectionData.SelectedSpeed}}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td scope="row">Input Power (Mechanical)</td>
                          <td id="IppowerMechImp">{{HpSpecDataResponse.IppowerMechImp}}</td>
                          <td id="IppowerMechMet">{{HpSpecDataResponse.IppowerMechMet}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Input Torque (Mechanical)</td>
                          <td id="IptorqueImp">{{HpSpecDataResponse.IptorqueImp}}</td>
                          <td id="IptorqueMet">{{HpSpecDataResponse.IptorqueMet}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Input Torque Accel</td>
                          <td id="IptorqueAccellImp">{{HpSpecDataResponse.IptorqueAccellImp}}</td>
                          <td id="IptorqueAccellMet">{{HpSpecDataResponse.IptorqueAccellMet}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Input Power (Thermal)</td>
                          <td id="IppowerthermalImp">{{HpSpecDataResponse.IppowerthermalImp}}</td>
                          <td id="IppowerthermalMet">{{HpSpecDataResponse.IppowerthermalMet}}</td>
                        </tr>
                        <tr *ngIf="formSelectionData.SelectedDutyCycle=='yes' && Series=='HPNOFAN'">
                          <td scope="row">Input Power (Fan Thermal)</td>
                          <td id="IppowerFanThermalImp">{{HpSpecDataResponse.IppowerFanThermalImp}}</td>
                          <td id="IppowerFanThermalMet">{{HpSpecDataResponse.IppowerFanThermalMet}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Output Torque (Mechanical)</td>
                          <td id="OptorqueImp">{{HpSpecDataResponse.OptorqueImp}}</td>
                          <td id="OptorqueMet">{{HpSpecDataResponse.OptorqueMet}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Output Torque Accel</td>
                          <td id="OptorqueAccellImp">{{HpSpecDataResponse.OptorqueAccellImp}}</td>
                          <td id="OptorqueAccellMet">{{HpSpecDataResponse.OptorqueAccellMet}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Efficiency</td>
                          <td id="EfficiencyImp">{{HpSpecDataResponse.Efficiency}}</td>
                          <td id="EfficiencyMet">{{HpSpecDataResponse.Efficiency}}</td>
                        </tr>
                        <!-- <tr *ngIf="HpSpecDataResponse.specServiceFactor < 1">
                          <td scope="row" class="bg-danger">Service Factor</td>
                          <td class="bg-danger" id="specSF">{{ HpSpecDataResponse.specServiceFactor }}</td>
                          <td class="bg-danger"></td>
                        </tr> -->
                        <tr>
                          <td scope="row" class="bg-success sericeFactorStyle">SF Based on Mechanical Input Power</td>
                          <td class="bg-success sericeFactorStyle" id="specSF">{{ HpSpecDataResponse.specServiceFactor }}</td>
                          <td class="bg-success sericeFactorStyle"></td>
                        </tr>
                      </tbody>
                    </table>
              </div>
  
              <div class="col-md-6">
                  <table class="table table-bordered table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col">User Inputs</th>
                          <th scope="col">Values</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td scope="row">Input Power</td>
                          <td id="inputPower">{{formSelectionData.SelectedInputPower}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Units</td>
                          <td id="unit" style="text-transform: capitalize;">{{formSelectionData.SelectedUnits}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Input Speed</td>
                          <td>{{formSelectionData.SelectedSpeed}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Ratio</td>
                          <td>{{formSelectionData.SelectedRatio}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Duty Cycle &ge;50%</td>
                          <td style="text-transform: capitalize;">{{formSelectionData.SelectedDutyCycle}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Min Required Service Factor</td>
                          <td id="sf">{{formSelectionData.SelectedServiceFactor}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Output Speed</td>
                          <td>{{formSelectionData.SelectedOutputSpeed}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div id="divButtons" style="text-align: center;">
                      <div class="col-md-12">
                        <input id="Btn_largerSize" type="button" value="Larger Reducer" class="button m-1" (click)="largerReducer()">
                        <input id="Btn_smallerSize" type="button" value="Smaller Reducer" class="button m-1" (click)="smallerReducer()">
                        <input id="Btn_ChangeReducer" type="button" value="Change Reducer" class="button m-1" (click)="scrollToCommonSecondComponent()">
                      </div>
                      <div class="col-md-12">
                        <input id="Btn_ReducerSizeProceed" type="button" value="Proceed with Reducer Features" (click)="reducerFeature()" class="button btn btn-primary w-100 m-1 p-1" style="background-color: #59842b">
                      </div>
                      
                  </div>
              </div>
          </div>
          
          
            
      </div>
      </div>
    
    
</div>


<div *ngIf="signalStatus==false">
  <h4 style="color: red;">Please proceed from previous step</h4>
 </div>
</mat-expansion-panel>
</mat-accordion>
<app-rg-first-selection *ngIf="Series==='RG'"></app-rg-first-selection>
<app-hpa-first-selection *ngIf="Series==='HPA'"></app-hpa-first-selection>
<app-hpa-first-selection *ngIf="Series==='HPANOFAN'"></app-hpa-first-selection>
<app-b-first-selection *ngIf="Series==='B'"></app-b-first-selection>
<!-- <app-f-first-selection *ngIf="Series === 'F'"></app-f-first-selection> -->